import { Button, Div } from '@codesuma/baseline'
import style from './index.module.css'

// Papa List–style hamburger: three stacked bars of unequal width. Positioning
// (and the click handler) is supplied by the caller; this owns only the glyph.
export const MenuIcon = () => {
    const base = Button()
    base.addClass(style.base)
    base.attr('aria-label', 'منو')
    base.attr('data-ripple', '')

    for (const width of [style.top, style.middle, style.bottom]) {
        const bar = Div()
        bar.addClass(style.bar)
        if (width) bar.addClass(width)
        base.append(bar)
    }

    return base
}
